import React from 'react';
import styles from './style.module.css';
import img1 from "../../assets/aboutImg.png";
import img2 from "../../assets/aboutImg1.png"
import logo1 from "../../assets/Logo Client 1.png";
import logo2 from "../../assets/Logo Client 2.png";
import logo3 from "../../assets/Logo Client 3.png";
import logo4 from "../../assets/Logo Client 4.png";
import logo5 from "../../assets/Logo Client 5.png";
import Frame1 from "../../assets/Frame 1.png"
import Team1 from "../../assets/Item - Team 10.png"
import Team2 from "../../assets/Item - Team 11.png"
import Team3 from "../../assets/Item - Team 12.png"
import cardImg1 from "../../assets/aboutImg3.png"
import cardImg2 from "../../assets/aboutImg4.png"
import cardImg3 from "../../assets/aboutImg5.png"
import missionImg from "../../assets/ourMission.png"
import vissionImg from "../../assets/ourVision.png"

const AboutUs = () => {
    const stats = [
        { number: "371+", label: "Project Delivered" },
        { number: "160+", label: "Surveys" },
        { number: "55+", label: "Associate & Partners" },
        { number: "123+", label: "TVET & Skills Consultancies" },
        { number: "17+", label: "MOUs with Universities" },
        { number: "33+", label: "Collaborations & NDAs with Statistical Agencies" },
        { number: "5,000+", label: "Satisfied Customers" },
        { number: "40+", label: "Countries" },
    ];
    return (
        <div className={styles.container}>
            <div className={styles.imageContainer}>
                <img src={img1} alt="About Us" className={styles.image1} />
                <div className={styles.textOverlay}>
                    <p className={styles.heading1}>ABOUT US</p>
                    <h2 className={styles.heading2}>Discover in Depth About Us</h2>
                </div>
            </div>
            <div className={styles.heading}>
                <p className={styles.heading1}>ABOUT US</p>
                <h2 className={styles.heading2}>Tailored Solutions for a</h2>
                <h2 className={styles.heading3}>Thriving Global Workforce</h2>
            </div>
            <div className={styles.container1}>
                <div className="row gx-0 mt-2 mb-2">
                    <div className={styles.imageContainer1}>
                        <img src={img2} alt="About us content" className={styles.image2} />
                    </div>
                    <div className={styles.textContainer}>
                        <div className={styles.textWrapper}>
                            <p>
                                As a human resource development consulting and training firm, DPBG draws on the diverse expertise of its team members, directors, and associates to achieve innovative and creative solutions to human resource development by focusing on human capital, data science research, labour market and social surveys, and human resource development needs.
                                It was established to assist global corporations and organisations in meeting the challenges of today’s complex business and training environments. DPB offers innovative, customized consultancy services to small, medium, and large organisations and operates across all industries and sub-sectors. It offers a consulting-led, integrated portfolio of services which combines insight and innovation from multiple disciplines with business knowledge and industry expertise to help clients exceed their expectations. These services are delivered through the company’s unique Delivery Model in four broad areas:
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <div className={styles.container2}>
                <div className={styles.statsGrid}>
                    {stats.map((stat, index) => (
                        <div key={index} className={styles.statItem}>
                            <h2 className={styles.statNumber}>{stat.number}</h2>
                            <p className={styles.statLabel}>{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.container3}>
                <h1 className={styles.title}>How we are changing this world</h1>
                <div className={styles.cardsContainer}>
                    <div className={styles.card}>
                        <img src={cardImg1} alt="Education and Training" className={styles.cardImage} />
                        <p className={styles.cardText}>Education and Training</p>
                    </div>
                    <div className={styles.card}>
                        <img src={cardImg2} alt="Capacity Building & Institutional Strengthening" className={styles.cardImage} />
                        <p className={styles.cardText}>Capacity Building & Institutional Strengthening</p>
                    </div>
                    <div className={styles.card}>
                        <img src={cardImg3} alt="Human Resource Development" className={styles.cardImage} />
                        <p className={styles.cardText}>Human Resource Development</p>
                    </div>
                </div>
            </div>
            <div className={styles.container4}>
                <div className={styles.container4Left}>
                    <h2 className={styles.heading4}>Why Choose Us</h2>
                    <p className={styles.description}>
                        DPB Global combines deep expertise in labor market analysis, statistical insights, and innovative technology to drive your digital transformation and workforce success. Choose us for data-driven strategies and impactful solutions.
                    </p>
                    <button className={styles.button}>Explore our Services</button>
                </div>
                <div className={styles.container4Right}>

                    <div className={styles.card1}>
                        <div className={styles.icon}>
                            <img src={vissionImg} alt="Logo 1" />
                        </div>
                        <h3 className={styles.cardTitle}>Our Vision</h3>
                        <p className={styles.cardText1}>
                            A prosperous region is developed through leading research and statistical data generation, inspiring excellence in leadership and management...
                        </p>
                        <a href="#" className={styles.readMore}>Read More</a>
                    </div>
                    <div className={styles.card2}>
                        <div className={styles.icon}><img src={missionImg} alt="Logo 1" /></div>
                        <h3 className={styles.cardTitle}>Our Mission</h3>
                        <p className={styles.cardText1}>
                            Through our work, exceed customer expectations, empower decision-making, and contribute to the success of businesses and our valued clients...
                        </p>
                        <a href="#" className={styles.readMore}>Read More</a>
                    </div>
                </div>


            </div>
            <div className={styles.companylogo}>
                <div className={styles.logoContainer}>
                    <img src={logo1} alt="Logo 1" className={styles.logo} />
                    <img src={logo2} alt="Logo 2" className={styles.logo} />
                    <img src={logo3} alt="Logo 3" className={styles.logo} />
                    <img src={logo4} alt="Logo 4" className={styles.logo} />
                    <img src={logo5} alt="Logo 5" className={styles.logo} />
                </div>
            </div>



            <div className=" d-flex justify-content-center align-items-center">
                <img src={Frame1} alt="Frame 1" className={`${styles.Frame1} img-fluid d-block max-auto`} ></img>
            </div>

            <div className=" ">
                <div className={`${styles.Team}`}>
                    <img src={Team1} alt="Team 1" className={`${styles.Team1} img-fluid d-block `}></img>
                    <img src={Team2} alt="Team 2" className={`${styles.Team2} img-fluid d-block `}></img>
                    <img src={Team3} alt="Team 3" className={`${styles.Team3} img-fluid d-block`}></img>
                </div>
            </div>



        </div>
    );
};

export default AboutUs;
